var p = /* @__PURE__ */ ((t) => (t.TopLeft = "top-left", t.TopCenter = "top-center", t.TopRight = "top-right", t))(p || {});
const e = ["top-left", "top-center", "top-right"];
export {
  e as TAB_SET_LAYOUTS,
  p as TabSetLayout
};
